<template>
  <Popup class="coupon-list-popup" v-model="show" :title="$t('coupon.coupon')">
    <div class="coupon-list-body" :class="displayModeClassName">
      <CouponCard
        v-for="(data, index) in coupons"
        class="card-item"
        :key="index"
        :data="data"
        :selectedCoupons="selectedCoupons"
        @click="handleChoice"
      />
    </div>
  </Popup>
</template>
<script>
  // 优惠券列表
  import Popup from '../Popup/index.vue'
  import CouponCard from './CouponCard'
  import {
    isValidTime,
    updateCouponSelected,
    checkSelectedIsOverlay,
    switchSelectedCoupon,
  } from '../utils'
  import { mapGetters } from 'vuex'

  export default {
    props: {
      // v-mode 是否展示弹窗
      value: {
        type: Boolean,
        default: false,
      },
      // 全部的优惠券数据
      coupons: {
        type: Array,
        default: () => {},
      },
      // 优惠后价格
      couponAfterMoney: {
        type: [String, Number],
        default: 0,
      },
    },
    components: {
      Popup,
      CouponCard,
    },
    data() {
      return {
        show: this.value,
        couponDatas: [],
        selectedCoupons: [],
      }
    },
    computed: {
      ...mapGetters(['displayModeClassName']),
      couponList() {
        return this.coupons && this.coupons.length > 0 ? this.coupons : []
      },
    },
    watch: {
      value(val) {
        this.show = val
      },
      show(val) {
        this.$emit('input', val)
      },

      couponList: {
        handler(newVal) {
          if (newVal && newVal.length) {
            this.couponDatas = newVal
            const res = newVal.filter((item) => item.selected) || []
            // 需要这种情况：从选中优惠券到未选中，res的length可以为0
            if (res) {
              this.selectedCoupons = res
              this.$emit('onSelectedCoupons', res)
            }
          }
        },
        deep: true,
        immediate: true,
      },
    },
    methods: {
      handleChoice(data) {
        let _couponDatas = []
        // 选中/切换优惠券
        // 如果当前券是不可用优惠券，或者不在有效期内不可选中
        if (!data.webEnable || !isValidTime(data)) return
        // 如果用户选择的券都是可以叠加的，且总金额大于或者等于商品价格的时候，不再支持勾选，但是支持取消
        if (
          this.couponAfterMoney < data.conditionPrice &&
          checkSelectedIsOverlay(this.coupons, data)
        ) {
          _couponDatas = switchSelectedCoupon(this.coupons, data)
        } else {
          _couponDatas = updateCouponSelected(this.coupons, data)
        }

        this._onSelectedCoupons(_couponDatas)
      },

      _onSelectedCoupons(coupns = []) {
        if (!(coupns && coupns.length)) return

        let res = coupns.filter((item) => item.selected)
        this.$emit('onSelectedCoupons', res)
      },
    },
  }
</script>

<style lang="scss" scoped src="./index.scss"></style>
